module.exports = __webpack_public_path__ + "static/media/Incorrect.3ad1a6fb.svg";